import React, { createContext, useContext, useMemo } from 'react';
import { createUniqueKey } from '../iframe/channel';

type UniqueKeyContext = {
	uniqueKey: string | undefined;
};

const UniqueKeyContext: React.Context<UniqueKeyContext> = createContext<UniqueKeyContext>({
	uniqueKey: undefined,
});

// When there are multiple embedded confluence instances on the same page,
// we need to use a unique key to identify each instance to avoid communication conflicts.
export const UniqueKeyProvider = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	const uniqueKey = useMemo(() => createUniqueKey(), []);
	return <UniqueKeyContext.Provider value={{ uniqueKey }}>{children}</UniqueKeyContext.Provider>;
};

export const useUniqueKey = (): UniqueKeyContext => {
	return useContext(UniqueKeyContext);
};
